import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/minimal-responses']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const saveMinimalQuestionnaireResponses = async ({ questionnaireId, update }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/minimal-responses', { questionnaireId });
  const data = await formsBackendClient.put(path, { update });
  return data.data;
};

export default saveMinimalQuestionnaireResponses;
